import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Input, FormFeedback, Label } from 'reactstrap';

/**
 * One controlled promo-date picker: label + DatePicker with a read-only
 * Input as customInput and manually managed open state.
 *
 * `field` is the usual { value, invalid, error } form-field object.
 * Linked range pickers pass selectsStart/selectsEnd + startDate/endDate;
 * standalone pickers omit them. saleEndDate is the only non-clearable one.
 */
const PromoDateField = ({
  label,
  htmlFor,
  field,
  open,
  onOpen,
  onClose,
  onChange,
  isClearable = false,
  selectsStart = false,
  selectsEnd = false,
  startDate,
  endDate,
}) => {
  const linkProps = {};
  if (selectsStart) linkProps.selectsStart = true;
  if (selectsEnd) linkProps.selectsEnd = true;
  if (selectsStart || selectsEnd) {
    linkProps.startDate = startDate;
    linkProps.endDate = endDate;
  }

  return (
    <div className="w-100">
      <Label for={htmlFor} className="text-gray font-weight-bold">
        {label}
      </Label>
      <DatePicker
        customInput={
          <>
            <Input
              value={
                field.value ? moment(field.value).format('DD/MMM/YYYY') : ''
              }
              invalid={field.invalid}
              onClick={onOpen}
            />
            <FormFeedback invalid="true">*{field.error}</FormFeedback>
          </>
        }
        open={open}
        className="form-control"
        selected={field.value}
        {...linkProps}
        dateFormat="dd/MMM/yyy"
        showYearDropdown
        onChange={onChange}
        disabledKeyboardNavigation
        onClickOutside={onClose}
        isClearable={isClearable}
      />
    </div>
  );
};

export default PromoDateField;
